import { IWizardStep } from "../../../wizard/types";
import ViewApplication from "./ViewApplication";

export const viewContentConfig: IWizardStep = {
  width: "720px",
  titleConfig: {
    titleText: "View",
  },
  content: ViewApplication,
  stepName: "step1",
};
